// links.js
const links = [
  { "name": "Home", "url": "/" },
  { "name": "Properties", "url": "/properties" },
  { "name": "About Us", "url": "/about" }
];

export default links;
